import { EntityType, isValidEntityType } from "../types";
import { ENTITY_TYPE_PARAMETER } from "../helpers/constants/miscellaneous";
import useAllQueryParamsFilters from "./useAllQueryParamsFilters";

export const useEntityType = (): EntityType => {
  const queryParams = useAllQueryParamsFilters();
  return isValidEntityType(queryParams[ENTITY_TYPE_PARAMETER])
    ? queryParams[ENTITY_TYPE_PARAMETER]
    : "IMAGES";
};
